import { render } from "./VUEGestionale.vue?vue&type=template&id=0df82a28&scoped=true"
import script from "./VUEGestionale.vue?vue&type=script&lang=js"
export * from "./VUEGestionale.vue?vue&type=script&lang=js"

import "./VUEGestionale.vue?vue&type=style&index=0&id=0df82a28&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0df82a28"]])

export default __exports__